// Single source of truth for recurring plan pricing.
// Previously duplicated across Billing.js, Checkout.js (removed), and
// SubscriptionManagement.js — keep prices here so they can never drift.

export const PLAN_PRICING = {
    Standard: { monthly: 4.99, annually: 49.99 },
    Premium: { monthly: 9.99, annually: 95.99 },
    Enterprise: { monthly: 'Contact sales', annually: 'Contact sales' },
};

// Stripe recurring price IDs, keyed by plan + billing cycle.
export const PLAN_PRICE_IDS = {
    Standard: { monthly: 'price_1RHOgxK0cSs6yAeTY4mwEMMZ', annually: 'price_1RHOgxK0cSs6yAeT38dhronu' },
    Premium: { monthly: 'price_1RHOkkK0cSs6yAeTFtoiFIZi', annually: 'price_1RHOkkK0cSs6yAeT3u6MgEM6' },
};

// Convenience getter that returns a display-safe price string.
export const getPlanPrice = (planType, billingCycle) =>
    PLAN_PRICING[planType]?.[billingCycle] ?? '0.00';
